










import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
  import Button from "@/shared/components/ui/Button.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

  @Component ({
    components: {
      Button,
    }
  })
  export default class AddFamilyMember extends Vue {
    @Prop()
    addNewFamilyMember: (personType) => void;

    custodianSettingsStore = useCustodianSettingsStore();

    addNewPerson (type) {
      this.addNewFamilyMember(type);
    }
  }
